import styled, { css } from 'styled-components'
import { dvrTime } from '../../../components/Player/Kaltura/Kaltura.styles'
import { device } from '../../../styles/GlobalVariables'
import { playerConfig } from '../../../components/Player/Helpers'

const { MobileBreakPoint } = playerConfig

export const PlayerWrap = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;

  .playkit-right-controls {
    z-index: 1;
  }
`
export const PlayerDiv = styled.div<{ type: string }>`
  position: relative;
  min-height: 100px;
  aspect-ratio: 16 / 9;
  max-height: ${(960 * 9) / 16}; //calc(960px * 9 / 16)
  max-width: 960px;
  margin: auto;
  direction: ltr;

  ${props =>
    props.type === 'linear'
      ? css`
          width: 100%;
          height: calc(100vw * 9 / 16);

          ${device.small} {
            height: 100%;
          }
        `
      : css`
          width: 100vw;
          height: calc(100vw * 9 / 16);
        `}

  ${props =>
    (props.type === 'episode' || props.type === 'trailer') &&
    css`
      & div.playkit-player .playkit-bottom-bar .playkit-right-controls {
        right: 5.5%;
        position: relative;
        padding-bottom: 5px;
        z-index: 5;
      }

      & div.playkit-player .playkit-bottom-bar .playkit-left-controls {
        left: 5.5%;
        position: relative;
        padding-bottom: 5px;
        z-index: 5;
      }

      position: relative;
      min-height: 100px;
      max-height: calc(1120px * 9 / 16);
      width: 99vw;
      height: calc(100vw * 9 / 16);
      max-width: 100%;
    `}
  ${dvrTime()};

  .adFlag {
    font-weight: 700;
    opacity: 0.8;
    color: white;
    background-color: rgb(72, 87, 101);
    padding: 4px 10px;
    right: 0;
    top: 0;
    z-index: 2;
    position: absolute;
    font-size: 17px;
    @media (max-width: ${MobileBreakPoint}px) {
      padding: 3px 6px;
      margin-right: 0;
      font-size: 14px;
    }
    display: ${props => (props.theme.showingAd ? 'block;' : 'none;')};
  }
`
